import { render, staticRenderFns } from "./file-item.vue?vue&type=template&id=04917e5b&scoped=true&"
import script from "./file-item.vue?vue&type=script&lang=js&"
export * from "./file-item.vue?vue&type=script&lang=js&"
import style0 from "./file-item.vue?vue&type=style&index=0&id=04917e5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04917e5b",
  null
  
)

export default component.exports